<template>
  <div>
    <keep-alive>
      <router-view v-if="keep_alive" :title="title"></router-view>
    </keep-alive>
    <router-view v-if="!keep_alive" :title="title"></router-view>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'enterprice',
  props: {
    title: {},
    transition: {}
  },
  computed: {
    // ...mapGetters([
    //   'enterprise_id'
    // ])
    keep_alive () {
      return this.$route.meta.keep_alive
    }
  },
  methods: {
    // ...mapActions([
    //   'setEnterpriseId',
    //   'getHomePageNav'
    // ])
  },
  created () {
    // this.getHomePageNav()
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Enterprise.vue?ded651fa